import React, { Component } from "react";
import { Link } from "react-router-dom";
import { QuestionnairesList } from "../components/QuestionnairesList/QuestionnairesList.js";
import { PERMISSIONS, QUESTIONNAIRE_TYPES } from "../../../../consts/api.js";
import { PaperworkMenu } from "../components/PaperworkMenu/index.js";
import { PaperworkLayout } from "../components/PaperworkLayout/index.js";
import { withPermission } from "../../../../hooks/usePermission.js";
import { PaperworkHeader } from "../components/PaperworkHeader/index.js";
import { PaperworkSearchInput } from "../components/PaperworkSearchInput/index.js";

class ProcedureTemplate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      term: "",
    };
  }

  render() {
    return (
      <PaperworkLayout>
        <PaperworkHeader>
          <div className="d-flex align-center gap-8">
            <PaperworkSearchInput
              onSearch={(term) => this.setState({ term })}
            />
            {this.props.manageQuestionnaires.permitted && (
              <Link
                to="/settings/procedure-template/create"
                className="new-blue-btn pull-right edit_setting"
              >
                Create Questionnaire
              </Link>
            )}
          </div>
        </PaperworkHeader>
        <PaperworkMenu active="multiQ" />
        <div className="juvly-section full-width">
          <div className="table-responsive">
            <table className="table-updated setting-table no-td-border no-hover">
              <thead className="table-updated-thead">
                <tr>
                  <th className="col-xs-6 table-updated-th sorting">
                    Templates
                  </th>
                  <th className="col-xs-3 table-updated-th sorting">
                    Number of Questions
                  </th>
                  <th className="col-xs-3 table-updated-th sorting text-center">
                    Actions
                  </th>
                </tr>
              </thead>
              <QuestionnairesList
                type={QUESTIONNAIRE_TYPES.multi}
                searchTerm={this.state.term}
              />
            </table>
          </div>
        </div>
      </PaperworkLayout>
    );
  }
}

export default withPermission(
  PERMISSIONS.settings.manageQuestionnaires,
  "manageQuestionnaires",
)(ProcedureTemplate);
